import "./gen-sdk";
import GameController from "./integration";

declare global {
  interface Window {
    gamezop: {
      pause: () => void;
      play: () => void;
      mute: () => void;
      unmute: () => void;
    };
  }
}

interface SDKEvent {
  data: EventData;
  gameCode: string;
  type: "update" | "message" | "loading";
}

interface EventData {
  leaderboard: {
    id: string;
  };
  metadata: {
    showTutorial: boolean;
    lang: string;
  };
  score: number;
  state: GameState;
}

enum GameState {
  Loaded = "loaded",
  Start = "start",
  Playing = "playing",
  Paused = "paused",
  LevelUp = "levelup",
  Over = "over",
  OverServer = "over-server",
  Continue = "continue",
  Idle = "idle",
  MetaUpdate = "meta-update",
}

class GamezopSDKEvent {
  constructor() {
    GameController.fetchGDSDK();
    if (document?.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.start.bind(this));
    } else {
      this.start();
    }
  }

  private start() {
    GameController.integrateAzerionSDKWithGameEvents();
    this.listen();
    GameController.initialize();
  }

  private listen() {
    window.addEventListener("message", this.onEvent);
  }

  private onEvent(e: MessageEvent<SDKEvent>) {
    const { data } = e.data || {};
    const { state, score } = data || {};

    const initialState = state === GameState.Playing && score === 0;
    const leveledUpOrOver =
      state === GameState.LevelUp || state === GameState.Over;

    if (initialState || leveledUpOrOver) {
      GameController.showAd()
    }
  }
}

new GamezopSDKEvent();
